module.exports = __webpack_public_path__ + "img/Brandeinsatz.d64a16d9.jpg";